<template>
    <div>
        <base-crud
                crudName="Classes x Receitas"
                newText="Novo vínculo"
                :table="questionClassTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="false"
                :enableEdit="true"
                :enableDelete="false"
                :enableView="false"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from "../Base/BaseCrud";

    export default {
        data: function () {
            return {
                questionClassTable: "questionClassTable",
                _data: [],
                pages: [],
                url: "",
                columns: ["class", "min", "max", "actions"],
                tableData: [],
                options: {
                    sortable: ["class", "min", "max"],
                    pagination: {chunk: 10, dropdown: false, nav: "scroll"},
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    headings: {
                        'class': 'Classe',
                        'min': 'Pontuação Mínima',
                        'max': 'Pontuação Máxima',
                        'actions': 'Ações'
                    }
                },
                endPoint: "questionClass/"
            };
        },
        components: {
            BaseCrud
        }
    };
</script>

<style>
    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/ClassXRecipe/Crud.vue